import {hasValue} from '@famly/stat_ts-utils_has-value';

import {loginId, secret} from './local-storage-vars';
import {readEncryptedValue} from './encrypted-values';
import {getFromLocalStorage} from './get-from-local-storage';
import {buildUserKey} from './build-user-key';

/**
 * Checks if the given key exists in the user's localstorage
 *
 * @param key key to check for existence
 * @returns true, if key exists in user's localstorage, false otherwise
 */
export function existsForUser(key: string) {
    if (!loginId || !secret) {
        return false;
    }
    const userKey = buildUserKey(loginId, key);
    return hasValue(readEncryptedValue(userKey)) || hasValue(getFromLocalStorage(userKey));
}
